import $ from 'jquery'

export default {
    name: 'constantes',
    components: {},
    props: ['consultation', 'is_printable'],
    data() {
        return {
            imc: null,
            taille: '',
            consultationLatest: null,
            examCliniqueSavePending: false,

            constantes: {
                temperature: null,
                tension_arterielle: null,
                poids: null,
                taille: null,
                pouls: null,
                etat_id: null,
                organe: []
            },

            additional_empty: false,
        }
    },

    watch: {
        consultation() {
            this.computeIMC()
        }
    },

    computed: {
        champ() {
            return this.DataFormat()
        },

        consultationEnCours() {
            return this.$store.getters["consultationPatientEnCours"]
        },

        etatsPatient() {
            return this.$store.getters["etatsPatient"]
        },

        user_role() {
            return this.$store.getters['activeRole'].nom;
        },

        champs_exm_clinique_historique() {
            return this.$store.getters["champs_exm_clinique_historique"];
        },

        patient(){
            return this.$store.getters['patient'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    created() {},


    async mounted() {
        setTimeout(() => {
            this.computeIMC()
        }, 1000);
        this.getHistoriqueExamenClinique()

        let tm = new Date()
        this.filename = 'Consultation_'+this.patient.nom+' '+this.patient.prenoms+'_'+tm.getTime()
    },
    methods: {
        async getHistoriqueExamenClinique() {
            this.$store.dispatch("getChampExamClinique", 
                { 
                    data_type: 'examen_clinique', consultation_id: this.consultation.id, 
                    en_cours: false, type_consultation_id: this.consultation.tarif_consultation.type_consultation.id
                }
            ).then(async() => {
                if (this.champs_exm_clinique_historique.length > 0) {
                    this.additional_empty = false
                } else {
                    this.additional_empty = true
                }

                this.$emit("emitHistoriqueConsultation", this.champs_exm_clinique_historique)
            })
        },

        onChildEmitted: function(value) {
            console.log(value)
            let length = this.consultationLatest.organes.length
            for (let i = length; i < this.consultationEnCours.organes.length; i++) {
                this.consultationLatest.organes.push(this.consultationEnCours.organes[i])
            }

        },

        clearAll(index, selector) {

            $('#' + selector).val('')
            if (index == '1') {
                this.constantes.taille = ''
            } else if (index == '2') {
                console.log("s: ", selector)
                this.constantes.temperature = ''
            } else if (index == '3') {
                this.constantes.tension_arterielle = ''
            }
        },

        async computeIMC() {
            var taille = this.consultation.taille
            var poids = this.consultation.poids
            console.log("poids: ", poids);
            
            if (taille == null || poids == null || poids == '' || taille == '') {
                this.imc = null

            } else {
                // taille = taille.replace(",", ".")
                // poids = poids.replace(",", ".")
                this.taille = taille

                if (this.consultation.unite_taille == 'cm') {
                    taille = parseFloat(taille / 100)
                }

                if (this.consultation.unite_poids == 'g') {
                    poids = parseFloat(poids / 1000)
                }

                console.log("t: ", taille, "   == P: ", poids," ::: ",(poids / (taille * taille)));
                
                this.imc = poids / (taille * taille)

                console.log("imc: ", this.imc);
                this.imc = this.imc.toFixed(2)
            }
        },

        dotToComma(value) {
            if (value && value != '') {
                value = value.replace(".", ",")
            }

            return value
        },

        DataFormat: function() {

            Object.defineProperty(this.de, 'property1', {
                value: 42,
                writable: true
            });
            this.de.property1 = 1
            return this.de
        },
        /**
         * Ajoute le caractère slash (/) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
        async formatNumberToSlash(n, selector) {
            let nb_car = $('#' + selector).val().length;
            if (n == '1') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9m ]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + 'm ');
                }
            } else {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9/]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + '/');
                }
            }
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        printHistorique() {
            this.$store.commit('SET_RECAP_HISTORIQUE_CONSULTATION', this.champs_exm_clinique_historique)
        },
    }
}


